import { fetchFromLocal, saveToLocal, } from '../../../../utils/storage/session-storage-cache';
import { getTemplateFilters } from '../../../../utils/templateGrid/algolia.util';
import { searchTemplates } from './template.api';
const FILTERS_LOCAL_STORAGE_KEY = 'lihp';
const MAX_AGE_IN_MILLS = 24 * 60 * 60 * 1000;
const payload = {
    count: 1,
    offset: 0,
    workflow: 'marketing',
    query: {
        categories_info: [],
        category: false,
        dimensions: [],
        favourites: false,
        industries: [],
        purchased: false,
        search_term: '',
    },
};
export const fetchFilters = () => {
    const cache = fetchFromLocal(FILTERS_LOCAL_STORAGE_KEY);
    if (cache)
        return Promise.resolve(cache);
    return searchTemplates(payload)
        .then(({ facets }) => getTemplateFilters(facets))
        .then(filters => saveToLocal(filters, FILTERS_LOCAL_STORAGE_KEY, MAX_AGE_IN_MILLS));
};
